import React from 'react'
import AgTechHeaderDetail from '@agtech/web/components/Headers/AgTechHeaderDetail';
import { LotActionButton } from '../buttons/SaleLotButtons';
import AgTechFieldList from '@agtech/web/components/Fields/AgTechFieldList';
import { SaleLot, getLotStatus } from '@sales/data/lots/LotData';
import { SaleLotCategoryIndex } from '@sales/data/lots/categories/LotCategoryData';
import LotDialog from '../../dialogs/LotDialog';
import { LotProvider } from '@sales/data/lots/LotDataQueries';

const LotDetailPopUp = (props: { lot: SaleLot, lotCategories: SaleLotCategoryIndex }) => {
    return (
        <div className='row-based flex' style={{ height: 240, width: 360 }}>
            <LotProvider lotId={props.lot.id}>
                {(lot) => {
                    const lotCategoryData = props.lotCategories;
                    const lotCategory = lot.lotCategoryId ? lotCategoryData[lot.lotCategoryId] : undefined;

                    return (
                        <div className='stretched row-based flex'>
                            <AgTechHeaderDetail
                                header={'Lot ' + lot.lotNumber}
                                settings={{
                                    classes: 'py-2 px-3 border-b',
                                    content: {
                                        body: () => (
                                            <LotActionButton lot={lot} />
                                        )
                                    }
                                }}
                            />
                            <div className='flexed p-3 row-based bg-light-gray flex'>
                                <AgTechFieldList
                                    fields={[
                                        { name: 'Sale Order', value: lot.saleOrder.toString() },
                                        { name: 'Category', value: lotCategory?.name ?? 'N/A' },
                                        { name: 'Status', value: getLotStatus(lot) },
                                    ]}
                                />
                                <AgTechFieldList
                                    classes='mt-2'
                                    fields={[
                                        { name: 'Description', value: lot.lotDescription },
                                    ]}
                                />
                            </div>
                            <div className='column-based px-2 top-bordered flex' style={{ height: 40 }}>
                                <LotDialog.Button 
                                    lotId={props.lot.id} 
                                    classes='ml-auto button-link'
                                />
                            </div>
                        </div>
                    );
                }}
            </LotProvider>
        </div>
    )
}

export default LotDetailPopUp